import classNames from 'classnames'
import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import {
  IFormJBPHPContactChangeRequest,
  newHpContactRequest,
} from 'legacy/lut/classes/models/partner360/IFormHPContacts'
import { useJbpSettings } from 'legacy/lut/features/partner360/jbpSettings'
import { FC, useState } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'
import { selectRouteParams } from 'core-components/sitebuilder/store/selectors/selectRouteParams'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'
import { HPContactRequestEditor } from 'partner360/features/hpContacts'

import { REQUEST_ACTION_ADD } from './hpContacts/configs'

import styles from 'legacy/lut/components/widgets/public/partner360/P360WidgetPlaceholder.module.scss'

type Props = {
  showMessage?: boolean
  className?: string
}

/* TODO widget to remove */
export const P360WidgetPlaceholder: FC<Props> = ({ showMessage = false, className }) => {
  const [requestAccessTicket, setRequestAccessTicket] = useState<IFormJBPHPContactChangeRequest>()
  const [showRequestAccessDialog, setShowRequestAccessDialog] = useState(false)
  const [showDuplicateDialog, setShowDuplicateDialog] = useState(false)

  const partnerId = useSelector(selectRouteParams).pid
  const user = useSelector(selectUser)
  const { jbpSettings } = useJbpSettings()

  const jbpHpContactChangeRequestCrud = CrudStore.get(
    CrudStoreItemPartner360.JBPHPContactChangeRequest,
    'JBPSalesTeam-WithTickets'
  )

  const requestAccessHandler = () => {
    setRequestAccessTicket({
      ...newHpContactRequest,

      Email: user.email,
      FirstName: user.firstName,
      LastName: user.lastName,

      Roles: '',

      RequestAction: REQUEST_ACTION_ADD,
    })

    setShowRequestAccessDialog(true)
  }

  const applyRequestAccessHandler = async (request: IFormJBPHPContactChangeRequest) => {
    let requestDuplicate = false
    if (request) {
      if (!!request.TicketId && request.TicketId !== -1) {
        request = {
          ...request,
          EntryId: request.TicketId,
          Status: request.TicketStatus,
          Action: request.RequestAction,
        }
        await jbpHpContactChangeRequestCrud.update(
          { formId: '1217', code: 'jbp-hp-contact-change-request-1217' },
          [request]
        )
      } else {
        const isRequestAccess = request.RequestAction === REQUEST_ACTION_ADD
        if (isRequestAccess) {
          if (request.Email) {
            jbpHpContactChangeRequestCrud.setFilter({
              logic: Logic.AND,
              filters: [
                {
                  field: 'PartnerId',
                  operator: Operator.EQUAL,
                  value: request.PartnerId,
                },
                {
                  field: 'Email',
                  operator: Operator.EQUAL,
                  value: request.Email,
                },
              ],
            })
            jbpHpContactChangeRequestCrud.setPaging({
              page: 0,
              pageSize: 5,
            })
            const result = await jbpHpContactChangeRequestCrud.fetch()
            if (result && result.items && result.items.length > 0) {
              requestDuplicate = true
            }
          }
        }

        if (!requestDuplicate) {
          request = {
            ...request,
            EntryId: -1,
            Status: request.TicketStatus,
            Action: request.RequestAction,
          }
          await jbpHpContactChangeRequestCrud.create(
            { formId: '1217', code: 'jbp-hp-contact-change-request-1217' },
            [request]
          )
        }
      }
    }

    setShowRequestAccessDialog(false)
    if (requestDuplicate) {
      setShowDuplicateDialog(true)
    } else {
      jbpHpContactChangeRequestCrud.removeQueries(true)

      window.location.reload()
    }
  }

  return (
    <div className={classNames(styles.root, className)}>
      {showMessage && (
        <>
          <div className={styles.content}>
            <div className={styles.image}>
              <i className={classNames(jbpSettings.accessDeniedSettings?.icon)}></i>
            </div>
            <div className={styles.message}>
              <h3>
                <Translation htmlAvailable text="jbp-access-denied" />
              </h3>
              <Button className={styles.button} onClick={requestAccessHandler}>
                <Translation text="jbp-request-access-button" />
              </Button>
            </div>
          </div>

          <ModalDialog
            show={showRequestAccessDialog}
            size={'sm'}
            content={HPContactRequestEditor}
            contentProps={{
              isVisible: showRequestAccessDialog,
              currentHpContactRequest: (requestAccessTicket ||
                {}) as IFormJBPHPContactChangeRequest,

              partnerId: partnerId as string,
              leadId: -1,
              currentRole: '',
              isRequestAccess: true,

              onApply: applyRequestAccessHandler,
              onCancel: () => {
                setShowRequestAccessDialog(false)
              },
              //onSubmit: (item?: IFormHPContacts | IFormSalesTeamRequest) => Promise<void>
            }}
            onClose={() => setShowRequestAccessDialog(false)}
          />

          <ModalDialog
            show={showDuplicateDialog}
            onClose={() => setShowDuplicateDialog(false)}
            size={'xs'}
            content={() => (
              <div>
                <p className={styles.warning__title}>
                  <Translation text="jbp-request-access-duplicate-title" />
                </p>
                <p className={styles.warning__text}>
                  <Translation text="jbp-request-access-duplicate-text" />
                </p>
                <div className={styles.warning__buttons}>
                  <Button
                    variant={'contained'}
                    className={styles.warning__close}
                    onClick={() => {
                      setShowDuplicateDialog(false)

                      window.location.reload()
                    }}
                    color={'grey'}
                  >
                    OK
                  </Button>
                </div>
              </div>
            )}
          />
        </>
      )}
    </div>
  )
}
